//INPUT DATE
$(".input-date").each(function(){
  if($(this).val().length != ''){
    $(this).addClass("input-has-value");
  }
  else{
    $(this).removeClass("input-has-value");
  }
  $(this).on('change', function(){
    if($(this).val().length != ''){
      $(this).addClass("input-has-value");
    }
    else{
      $(this).removeClass("input-has-value");
    }    
  });
});
